import { ReactNode } from 'react';
import { CheckPicker } from '../../../../../components/CheckPicker';
import { InnerFilter } from '../../../../../components/FilterSection';
import { useNetworkFilterOptions } from '../../hooks/useNetworkFilterOptions';
import { NetworkFilterKey } from '../../types';

type NetworkFilterChipProps = {
  filterKey: NetworkFilterKey;
  placeholder: ReactNode;
  // Chips that accept a pasted list of codes (Produtos, Família) use the CheckPicker with the paste modal.
  pasteValues?: boolean;
  modalText?: string;
};

export const NetworkFilterChip = ({ filterKey, placeholder, pasteValues = false, modalText }: NetworkFilterChipProps) => {
  const { search, onConfirmPasteValues, ...pickerProps } = useNetworkFilterOptions(filterKey);

  if (pasteValues) {
    return (
      <CheckPicker
        {...pickerProps}
        search={search}
        // @ts-expect-error rsuite types the placeholder as string but renders a node, as in the price manager pills
        placeholder={placeholder}
        pasteValues
        onConfirmPasteValues={onConfirmPasteValues}
        modalText={modalText}
      />
    );
  }

  // InnerFilter consumes onClose; onExited reaches the underlying picker when it closes.
  return <InnerFilter type="check" {...pickerProps} onExited={pickerProps.onClose} placeholder={placeholder} />;
};
